// TEMPORARY (temp/linked-customer): verify numbers 2 and 3 in the Booking Form (real SMS / WhatsApp OTP).
import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { linkedApi, BASE } from "./linkedApi";
import { cleanDigits, validateSlot, slotPayload, verifiedSlots } from "./linkedLogic";

const SlotForm = ({ priority, done, customerId, api, onVerified }) => {
    const [phone, setPhone] = useState("");
    const [type, setType] = useState("normal");
    const [otp, setOtp] = useState("");
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);
    const slot = { phone, priority, type };

    if (done) return <div className="border rounded-3 p-3 mb-3"><strong>Number {priority}</strong> <span className="badge text-bg-success ms-2">Verified</span></div>;

    const send = async () => {
        const problem = validateSlot(slot);
        if (problem) return toast.error(problem);
        setBusy(true);
        const r = await api.phoneOtp(customerId, slotPayload(slot));
        setBusy(false);
        if (r.ok) { setSent(true); toast.success(r.message || "OTP sent"); if (r.data?.usedElsewhere) toast.info("This number is also used by another customer."); } else toast.error(r.message || "Could not send OTP");
    };
    const verify = async () => {
        if (!/^\d{6}$/.test(otp)) return toast.error("Enter the 6 digit OTP");
        setBusy(true);
        const r = await api.phoneVerify(customerId, slotPayload(slot), otp);
        setBusy(false);
        if (r.ok) { toast.success(r.message || "Number verified"); onVerified(); } else toast.error(r.message || "Could not verify");
    };

    return (
        <div className="border rounded-3 p-3 mb-3">
            <div className="fw-semibold mb-2">Number {priority}</div>
            <div className="row g-2">
                <div className="col-12 col-md-6">
                    <input className="form-control" inputMode="numeric" placeholder="10 digit mobile number" value={phone} disabled={sent}
                        onChange={(e) => setPhone(cleanDigits(e.target.value, 10))} />
                </div>
                <div className="col-12 col-md-6">
                    <select className="form-select" value={type} disabled={sent} onChange={(e) => setType(e.target.value)} aria-label="OTP channel">
                        <option value="normal">Send OTP by SMS</option>
                        <option value="whatsapp">Send OTP by WhatsApp</option>
                    </select>
                </div>
            </div>
            {sent ? (
                <div className="input-group mt-2">
                    <input className="form-control" inputMode="numeric" placeholder="6 digit OTP" value={otp} onChange={(e) => setOtp(cleanDigits(e.target.value, 6))} />
                    <button type="button" className="btn btn-primary" disabled={busy} onClick={verify}>{busy ? "Verifying..." : "Verify"}</button>
                    <button type="button" className="btn btn-outline-secondary" disabled={busy} onClick={() => { setSent(false); setOtp(""); }}>Change number</button>
                </div>
            ) : (
                <button type="button" className="btn btn-primary mt-2" disabled={busy} onClick={send}>{busy ? "Sending..." : "Send OTP"}</button>
            )}
        </div>
    );
};

const LinkedPhonesModal = ({ customerId, base = BASE, onClose, onChanged }) => {
    const api = useRef(linkedApi(base)).current;
    const modalRef = useRef(null);
    const [info, setInfo] = useState(null);
    const [error, setError] = useState("");

    const load = useCallback(async () => {
        const r = await api.phones(customerId);
        if (r.ok) { setInfo(r.data); setError(""); } else setError(r.message || "Could not load the Booking Form numbers");
    }, [api, customerId]);

    useEffect(() => { load(); }, [load]);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        const hidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", hidden);
        instance.show();
        return () => { el.removeEventListener("hidden.bs.modal", hidden); instance.hide(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const done = verifiedSlots(info?.phones);
    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">Verify 2 more numbers</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <p className="small text-muted">The Booking Form needs three verified numbers. Number 1 is the main number. A real OTP is sent to each number below.</p>
                        {error ? <div className="alert alert-danger py-2">{error}</div> : ""}
                        {info ? (
                            <>
                                <div className="small mb-3">Booking Form status: <strong>{info.status || "-"}</strong>
                                    {(info.phones || []).length ? <span className="text-muted"> · {(info.phones || []).map((p) => `${p.priority}: ${p.phone}${p.verified ? " ✓" : ""}`).join("  ")}</span> : ""}
                                </div>
                                {[2, 3].map((n) => <SlotForm key={n} priority={n} done={done[n]} customerId={customerId} api={api} onVerified={() => { load(); onChanged?.(); }} />)}
                            </>
                        ) : !error ? <div className="text-muted">Loading...</div> : ""}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkedPhonesModal;
